import { DEFAULT_SELECTED_DISPLAY_URL_INDEX, DEFAULT_SELECTED_SEARCH_TYPE_INDEX, DISPLAY_URL_LABEL_TEXT } from '../../../constants';
import { FieldType, OnlineDatabaseField } from '../../../../components/GenericSection/constants';
var ONLINE_DATABASE_PUBINFO_SECTION_FIELDS = [{
  fields: [{
    field: OnlineDatabaseField.LIBRARY,
    labelText: 'Library',
    recommended: false,
    type: FieldType.TEXT
  }, {
    field: OnlineDatabaseField.CITY,
    labelText: 'City',
    recommended: false,
    type: FieldType.TEXT
  }]
}, {
  fields: [{
    field: OnlineDatabaseField.DATABASE,
    labelText: 'Database',
    recommended: false,
    type: FieldType.TEXT
  }, {
    field: OnlineDatabaseField.SERVICE,
    labelText: 'Service',
    recommended: false,
    type: FieldType.TEXT
  }]
}, {
  field: OnlineDatabaseField.DATE_ACCESSED,
  type: FieldType.PUBDATE,
  labelText: 'Date accessed',
  formikFieldNames: ['dayaccessed', 'monthaccessed', 'yearaccessed']
}, {
  field: OnlineDatabaseField.SEARCH_TYPE,
  type: FieldType.RADIO_GROUP_WITH_INPUT,
  radioName: 'pubdatabase.searchtype',
  inputName: 'pubdatabase.searchtext',
  defaultSelectedIndex: DEFAULT_SELECTED_SEARCH_TYPE_INDEX,
  options: [{
    key: 'keyword',
    value: 'Keyword',
    placeholderText: 'Type keyword here'
  }, {
    key: 'path',
    value: 'Path',
    placeholderText: 'Ex: Science; Biology; Birds'
  }, {
    key: 'url',
    value: 'URL',
    placeholderText: 'http://'
  }],
  alignment: 'horizontal',
  labelText: 'Search type'
}, {
  type: FieldType.RADIO,
  labelText: DISPLAY_URL_LABEL_TEXT,
  options: [{
    key: 'yes',
    value: 'Yes'
  }, {
    key: 'no',
    value: 'No'
  }],
  defaultSelectedIndex: DEFAULT_SELECTED_DISPLAY_URL_INDEX,
  field: OnlineDatabaseField.DISPLAY_URL,
  alignment: 'horizontal'
}];
export default ONLINE_DATABASE_PUBINFO_SECTION_FIELDS;